import * as reference from './botPlacementReference.js';
import { scoreLine } from './scoring.js';
const lineScore = (cells, dictionary) => scoreLine(cells, dictionary).reduce((sum, word) => sum + word.score, 0);
// Experiment: six-hole boundary is a hypothesis, not an optimal threshold.
function chooseBotPlacement(options) {
  // Delegate validation and preserve the established choice as the tie-break.
  const fallback = reference.chooseBotPlacement(options);
  if (!fallback || options.difficulty !== 5) return fallback;
  const { dictionary, incomingLetter = null, letterChoices = reference.LETTERS } = options;
  const board = options.board.map(row => [...row]);
  const holes = [];
  board.forEach((row, r) => row.forEach((letter, c) => { if (letter === '') holes.push({row:r,col:c}); }));
  if (holes.length > (incomingLetter === null ? 5 : 6)) return fallback;
  const legal = value => typeof value === 'string' && /^[ABCÇDEFGĞHIİJKLMNOÖPRSŞTUÜVYZ]$/iu.test(value);
  const ownLetters = [...new Set(letterChoices.filter(legal).map(letter => letter.toLocaleUpperCase('tr-TR')))];
  const rows = board.map(row => lineScore(row,dictionary));
  const cols = board.map((_,c) => lineScore(board.map(row => row[c]),dictionary));
  function gain(position, letter, rowScores, colScores) {
    const {row:r,col:c} = position;
    board[r][c] = letter;
    const a = lineScore(board[r],dictionary), b = lineScore(board.map(row=>row[c]),dictionary);
    board[r][c] = '';
    return { value:a-rowScores[r]+b-colScores[c], a, b };
  }
  // Keep the previous move on equal objective values, avoiding arbitrary churn.
  const ordered = [fallback,...holes.filter(p=>p.row!==fallback.row || p.col!==fallback.col)];
  let best = null, bestValue = -Infinity;
  for (const position of ordered) {
    const letters = incomingLetter === null ? [fallback.letter,...ownLetters.filter(l=>l!==fallback.letter)] : [fallback.letter];
    for (const letter of letters) {
      const first = gain(position,letter,rows,cols);
      let value = first.value;
      if (incomingLetter !== null && holes.length > 1) {
        board[position.row][position.col] = letter;
        const nextRows = [...rows], nextCols = [...cols];
        nextRows[position.row] = first.a; nextCols[position.col] = first.b;
        let continuation = -Infinity;
        for (const next of holes) {
          if (next.row===position.row && next.col===position.col) continue;
          for (const own of ownLetters) continuation = Math.max(continuation,gain(next,own,nextRows,nextCols).value);
        }
        board[position.row][position.col] = '';
        if (Number.isFinite(continuation)) value += continuation;
      }
      if (value > bestValue) { bestValue=value; best={row:position.row,col:position.col,letter,scoreGain:first.value}; }
    }
  }
  return best || fallback;
}
const LETTERS = reference.LETTERS;
export { LETTERS, chooseBotPlacement };
